import { MapGeometry } from '@api/types';
import { create } from 'zustand';

type PlssData = {
  TWNSHPNO: string;
  TWNSHPDIR: string;
  RANGENO: string;
  RANGEDIR: string;
  FIRSTDIVNO: string;
};

interface PlssState {
  plssData: PlssData | null;
  plssGeometry: MapGeometry | null;
  isLoading: boolean;
  isError: boolean;
  getPlssGeometry: () => MapGeometry | null;
  getPlssData: () => PlssData | null;
  setPlssData: (data: PlssData) => void;
  setPlssGeometry: (geometry: MapGeometry) => void;
  setIsLoading: (loading: boolean) => void;
  setIsError: (error: boolean) => void;
}

export const usePlss = create<PlssState>((set, get) => ({
  plssData: null,
  plssGeometry: null,
  isLoading: false,
  isError: false,
  getPlssData: () => get().plssData,
  getPlssGeometry: () => get().plssGeometry,
  setPlssData: (data: PlssData | null) => set({ plssData: data }),
  setPlssGeometry: (geometry: MapGeometry | null) => set({ plssGeometry: geometry }),
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  setIsError: (error: boolean) => set({ isError: error }),
}));
